"use client";

import React from "react";
import {
  GA4DataLayer,
  GA4DataLayerFn,
} from "@packages/lib/utlils/helper-function";
import { DataLayerGA4AttrType, GA4EventAttrType } from "../types/datalayerGA";
import { GAConstants } from "@packages/shared-components/services/constants";
import {
  logClickstreamEvent,
  ClickstreamInterface,
} from "@packages/lib/utlils/clickstream";

interface ClickTrackingWrapperProps {
  children: React.ReactNode;
  gaData: GA4EventAttrType;
  clickstreamData?: ClickstreamInterface;
  oldGAData?: DataLayerGA4AttrType;
}

const ClickTrackingWrapper: React.FC<ClickTrackingWrapperProps> = ({
  children,
  gaData,
  clickstreamData,
  oldGAData,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    const clickedElement = e.target;
    const closestElement =
      clickedElement instanceof HTMLElement
        ? clickedElement.closest('[data-ga-track="visit-website"]')
        : null;
    const visitWebsiteElement =
      closestElement instanceof HTMLAnchorElement ? closestElement : null;

    if (visitWebsiteElement) {
      const ctaUrl = visitWebsiteElement.href;
      GA4DataLayer({
        ...gaData,
        event: GAConstants.revenue_kpi,
        event_name: "visit_website",
        cta_url: ctaUrl,
      });
      if (clickstreamData) {
        logClickstreamEvent({
          ...clickstreamData,
          externalUrl: ctaUrl,
          CTATitle: "Visit website",
          actionType: "Interaction",
          eventType: "VisitWebsite",
          functionalityName: "VisitWebsite",
        });
      }

      oldGAData &&
        GA4DataLayerFn({
          ...oldGAData,
          event: "visit website",
          eventName: "visit_website",
          cta_url: ctaUrl,
        });
    } else if (gaData.click_text !== "visit_website") {
      GA4DataLayer({ ...gaData });
      oldGAData && GA4DataLayerFn({ ...oldGAData });
    }
  };

  return (
    <div className="h-full w-full" onClick={handleClick}>
      {children}
    </div>
  );
};

export default ClickTrackingWrapper;
